import React from 'react';
import classNames from 'classnames';
import './style.scss';

const Tooltip = ({ children, className }) => (
    <div className={classNames('gig-tooltip', className)}>
        {children}
    </div>
);

export default Tooltip;



// WEBPACK FOOTER //
// ./src/shared/tooltip/index.js